import { useState } from 'react';
import { PermissionRole, ROLE_MAP } from 'pages/AddUser/AddUserForm/types';
import { JungianColours, LicensedProduct, Role } from 'types/types';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import RolePermissionV2 from './RolePermissionV2';

type EditRolePermissionProps = {
  roleChangeIsPermitted: boolean | undefined;
  isSuperAdmin: boolean;
  register: UseFormRegister<{
    fullName: string;
    emailAddress: string;
    leadingColourEnergy?: JungianColours | undefined;
    licensedProducts: LicensedProduct[];
    role: Role;
  }>;
  formData: {
    fullName: string;
    emailAddress: string;
    leadingColourEnergy?: JungianColours;
    licensedProducts: LicensedProduct[];
    role: Role;
  };
  setValue: UseFormSetValue<{
    fullName: string;
    emailAddress: string;
    leadingColourEnergy?: JungianColours | undefined;
    licensedProducts: LicensedProduct[];
    role: Role;
  }>;
  showRoles: boolean | undefined;
};

export const getHighestPermission = (role: Role): string => {
  if (role === 'SUPER_ADMIN') return 'CLIENT_SERVICES';

  const roleToPermissionMap: Record<Role, PermissionRole> = {
    SUPER_ADMIN: 'CLIENT_SERVICES',
    GROUP_MANAGER: 'GROUP_MANAGER',
    ADVANCED_USER: 'ADVANCED_USER',
    STANDARD: 'STANDARD',
    RESTRICTED_USER: 'RESTRICTED_USER',
  };
  return roleToPermissionMap[role] || 'STANDARD';
};

const EditRolePermission = ({
  roleChangeIsPermitted,
  isSuperAdmin,
  register,
  formData,
  setValue,
  showRoles,
}: EditRolePermissionProps) => {
  const defaultRoleType = getHighestPermission(formData.role);

  const [permissionRole, setPermissionRole] = useState<PermissionRole>(
    defaultRoleType as PermissionRole,
  );

  const changeRoleType = (value: string) => {
    setPermissionRole(value as PermissionRole);
    setValue('role', ROLE_MAP[value as PermissionRole]);
  };

  register('role', { required: true });

  let roleComponent = null;

  if (showRoles) {
    roleComponent = (
      <RolePermissionV2
        changeRoleType={changeRoleType}
        isSuperAdmin={isSuperAdmin}
        roleChangeIsPermitted={roleChangeIsPermitted}
        permissionRole={permissionRole}
      />
    );
  }

  return <div data-testid="edit-role-permission">{roleComponent}</div>;
};

export default EditRolePermission;
